/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Groupsnew1Inputs */

const en_groupsnew1 = /** @type {(inputs: Groupsnew1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New group`)
};

const de_groupsnew1 = /** @type {(inputs: Groupsnew1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neue Gruppe`)
};

/**
* | output |
* | --- |
* | "New group" |
*
* @param {Groupsnew1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const groupsnew1 = /** @type {((inputs?: Groupsnew1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Groupsnew1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_groupsnew1(inputs)
	return de_groupsnew1(inputs)
});
export { groupsnew1 as "groupsNew" }